import { render } from "./CustomDropFile.vue?vue&type=template&id=e48e2ca6&scoped=true"
import script from "./CustomDropFile.vue?vue&type=script&lang=js"
export * from "./CustomDropFile.vue?vue&type=script&lang=js"

import "./CustomDropFile.vue?vue&type=style&index=0&id=e48e2ca6&scoped=true&lang=css"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e48e2ca6"]])

export default __exports__